module.exports = __webpack_public_path__ + "img/xuchangLoginBk.cafbe99b.png";